<template lang="pug">
UiStack(vertical)
  UiStack
    UiStackItem(fill)
      .ui-card-section-title {{ $t("companies.approvers.target_approver") }}
    UiStackItem
      UiButton(
        variant="primary"
        @click="openAssignApprover"
        icon="Plus"
      ) {{ $t("companies.approvers.assign_approver") }}
  RestTable(
    namespace="target_approvers"
    :headers="headers"
    ref="TargetApproversTable"
    :fetch-handler="getData"
    disablePagination
  )
    template(#cell:actions="{ item }")
      UiButton(
        size="sm"
        variant="smooth-danger"
        @click="deassign(item)"
      ) Remove
  AssignApproverModal(
    ref="AssignApproverModal"
    @closed="reload"
  )
</template>
<script>
import ApiApprovers from "@/api/approvers.js";
import AssignApproverModal from "@/modals/Approvers/assignApprovers.vue";

export default {
  components: {
    AssignApproverModal,
  },
  props: ["target", "target_id"],

  data() {
    return {
      headers: [
        {
          key: "id",
          label: "#",
          cellClass: "text-nowrap",
        },
        {
          key: "approver_name",
          label: "Name",
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "price_limit",
          label: "Price limit",
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
      approver_options: [],
    };
  },

  methods: {
    reload() {
      this.$refs.TargetApproversTable.fetchData();
    },

    getData(params, config) {
      return ApiApprovers.fetchTargetApprover(
        this.$route.params.id,
        this.target,
        this.target_id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.approvers,
          meta: resp.data.meta,
        };
      });
    },

    openAssignApprover() {
      this.$refs.AssignApproverModal.open(
        this.target,
        this.target_id,
        "approver",
      );
    },

    deassign(item) {
      return new Promise((res) => {
        ApiApprovers.deassignApprover(
          this.$route.params.id,
          item.id,
          this.target,
          this.target_id,
          "approver",
        ).then((resp) => {
          this.reload();
        });
      });
    },
  },
};
</script>
